<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Hdvw2M/tc-custom/9781399016186.jpg?1733027514906" alt="This image is the cover for the book Selective History of 'Bad' Video Games"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Selective History of 'Bad' Video Games
      </h1>
      <p class="bookDescription body article font2">
        <p>Did you grow up playing video games when you had to wait online to get them? Do you remember the bad, weird, or otherwise underrated video games of your youth? Did you like a few of them more than your friends did?   A Selective History of ‘Bad’ Video Games will walk you down memory lane and perform unholy excavations of games you remember, games you’ve forgotten, and games you never knew you wanted to read about during your lunch break. From a seemingly nude Atari 2600 karate referee to a basketball star doing martial arts to a tiger that speaks broken English and walks through walls, the book will try to uncover what the developers were thinking — and occasionally succeed. While there’s been some recent coverage of the most famously “bad” video game — E.T. — this book starts there and continues on to 40 other curiously (or unsurprisingly) unsuccessful video games during the first few decades of the industry’s lifespan. Written by a modern day video game developer, the book explores why these games failed, whether or not they truly deserved it, and what could have made them better. The covered games include screen shots that capture awkward moments, irreverent captions, and pages of tongue-in-cheek psychoanalysis.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Greenhut
      </h2>
      
      <p class="authorDescription body article">Michael Greenhut was born in the Bronx, New York, in 1978. He is a professional game programr and an occasional writer of fiction and nonfiction. Currently, he lives in Fort Lee, NJ with his wife and son, and works for Playmatics. Michael has worked on casual games, educational games, and just plain weird games. His favorite video games are Final Fantasy IV, Suikoden 2, Chrono Trigger, and Life is Strange.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      White Owl
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27169d20